import React, { useEffect, useState } from 'react';
import IntlMessages from '../../../../../../helpers/IntlMessages';
import { Row } from 'reactstrap';
import { Colxx } from '../../../../../../components/common/CustomBootstrap';
const ItemTotalClicks = ({ itemList, avatarClick }) => {
    const [totalClick, setTotalClick] = useState(0);
    const [avarageClick, setAvarageClick] = useState(0);

    useEffect(() => {
        if (itemList !== undefined && itemList !== null && itemList.length > 0) {
            var count = 0;
            itemList.map(i => {
                count += i.clicks;
            });
            setTotalClick(count);
            var avg = parseFloat((count / avatarClick)).toFixed(2);
            setAvarageClick(avg);
        }
    }, [itemList]);

    return (
        <div className="iconcards-row row d-flex">
            <div className="mb-4 col-sm-4 col-lg-3 col-xl-3">
                <div className="card">
                    <div className="text-center card-body">
                        <i className="iconsminds-qr-code"></i>
                        <p className="card-text font-weight-semibold mb-0" style={{ lineHeight: "17px" }}>
                            <IntlMessages id="dashboards.compendium-total-qr-code" />
                        </p>
                        <p className="lead text-center" style={{ fontSize: "1.2rem" }}
                        >{avatarClick}</p>
                    </div>
                </div>
            </div>
            <div className="mb-4 col-sm-4 col-lg-3 col-xl-3">
                <div className="card">
                    <div className="text-center card-body">
                        <i className="iconsminds-cursor-click-2"></i>
                        <p className="card-text font-weight-semibold mb-0" style={{ lineHeight: "17px" }}>
                            <IntlMessages id="dashboards.compendium-total-digital-clicks" />
                        </p>
                        <p className="lead text-center" style={{ fontSize: "1.2rem" }}
                        >{totalClick}</p>
                    </div>
                </div>
            </div>
            <div className="mb-4 col-sm-4 col-lg-3 col-xl-3">
                <div className="card">
                    <div className="text-center card-body">
                        <i className="iconsminds-cursor-click"></i>
                        <p className="card-text font-weight-semibold mb-0" style={{ lineHeight: "17px" }}>
                            <IntlMessages id="dashboards.compendium-avg-menu-items" />
                        </p>
                        <p className="lead text-center" style={{ fontSize: "1.2rem" }}
                        >{avarageClick}</p>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default ItemTotalClicks;